import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import TextSuggest from '../textsuggest/TextSuggest';
import { InsertSuggestionEvent } from "../textsuggest/textsuggest.model";
import { SearchEvent, Segment, Suggestion } from "./search.model";

@Component({
    name: 'Search',
    components: {
        TextSuggest,
    },
})
export default class Search extends Vue {
    @Prop({ required: true })
    private readonly suggestions!: Suggestion<any, any, any>[];
    @Prop()
    private readonly placeholder!: string;

    private search: string = '';
    private readonly segments: Segment<any, any, any>[] = [];

    public setSearch(segments: Segment<any, any, any>[], search: string): void {
        this.segments.splice(0);
        this.segments.push(...segments);
        this.search = search;
        this.change();
    }

    private change(): void {
        let segments = this.segments.map(s => s.clone()); //deep copy, so that the internal state of the segments cannot be changed by an event handler
        let search = this.search;
        if (segments.length) {
            let lastseg = segments[segments.length - 1];
            if (!lastseg.operator
                || (!lastseg.value.trim().length && !search.trim().length)) { //last segment incomplete -> ignore segement + search
                segments = segments.splice(0, segments.length - 1);
                search = '';
            } else if (!lastseg.value.trim().length && search.trim().length) { //lastseg.value missing but search present
                let newlastseg = new Segment<any, any, any>(lastseg.suggestion);
                newlastseg.operator = lastseg.operator;
                newlastseg.value = search;
                search = '';
                segments[segments.length - 1] = newlastseg;
            }
        }
        this.$emit('search', new SearchEvent(segments, search));
    }

    //events
    private onBackspace(): void {
        let txt = this.txt();
        if (txt.selectionStart !== 0 || txt.selectionEnd !== 0
            || !this.segments.length) {
            return;
        }
        let seg = this.segments[this.segments.length - 1];
        if (seg.value) {
            seg.value = '';
        } else if (seg.operator) {
            seg.operator = null;
        } else {
            this.segments.splice(this.segments.length - 1);
        }
        this.change();
    }

    private onEnter(): void {
        if ((this.$refs.suggest as TextSuggest).shown) {
            return;
        }
        if (!this.segments.length || !this.search.trim().length) {
            return;
        }
        let seg = this.segments[this.segments.length - 1];
        if (seg.operator && !seg.value.length) {
            seg.value = this.search;
            this.search = '';
            this.change();
            return;
        }
    }

    private onInsertSuggestion(event: InsertSuggestionEvent): void {
        if (!this.segments.length) {
            let s = new Segment(this.suggestions.find(e => e.display.toLocaleLowerCase() === event.suggestion.toLocaleLowerCase())!);
            this.segments.push(s);
        } else {
            let seg = this.segments[this.segments.length - 1];
            if (!seg.operator) {
                seg.operator = seg.suggestion.operators.find(e => e.display === event.suggestion)!;
            } else if (!seg.value.length) {
                seg.value = event.suggestion;
            } else {
                let s = new Segment(this.suggestions.find(e => e.display.toLocaleLowerCase() === event.suggestion.toLocaleLowerCase())!);
                this.segments.push(s);
            }
        }
        event.preventDefault();
        this.search = '';
        this.txt().value = ''; //need to be set or text suggest won't open next suggestion
        this.change();
        // this.txt().dispatchEvent(new Event('keydown', { key: " ", ctrlKey: true } as KeyboardEventInit))
    }

    private txt(): HTMLInputElement {
        return this.$refs.txt as HTMLInputElement;
    }

    private get suggestionStrings(): string[] {
        let ret: string[] = [];
        if (!this.segments.length) {
            ret.push(...this.suggestions.map(e => e.display));
        } else {
            let seg = this.segments[this.segments.length - 1];
            if (!seg.operator) {
                ret.push(...seg.suggestion.operators.map(e => e.display));
            } else if (!seg.value.length) {
                ret.push(...seg.suggestion.values);
            } else {
                ret.push(...this.suggestions.map(e => e.display));
            }
        }

        console.log('suggestionStrings', ret.filter(e => !this.search || e.toLocaleLowerCase().includes(this.search.toLocaleLowerCase())))

        return ret.filter(e => !this.search || e.toLocaleLowerCase().includes(this.search.toLocaleLowerCase()));
    }

    private get placeholderString(): string {
        if (this.placeholder) {
            return this.placeholder;
        }
        return this.$t('txtSearch').toString();
    }
}
